import { getResultsStepFromPosition, isResultsPositionAvailable } from '../Postflop/resultsPositionOptions';
import { isForcedPostflopChallenge } from '../../utils/postflopPractice';

// Results and coverage exclude forced opening decisions. Keep this separate
// from the setup options, where these nodes remain visible with Start disabled.
const isResultsStatPositionAvailable = (
  isPlo5, tableSize, stackSize, positionType, position, boardType, handType,
) => (
  isResultsPositionAvailable(
    isPlo5, tableSize, stackSize, positionType, position, boardType, handType,
  )
  && !isForcedPostflopChallenge({
    isPlo5,
    tableSize,
    stackSize,
    positionType,
    boardType,
    handType,
    currentStep: getResultsStepFromPosition(position),
  })
);

export default isResultsStatPositionAvailable;
